// A readable message for a failed request. A 404 from the API almost always
// means the server is running older code than this app expects.
// Retry only network failures and server crashes; a 4xx won't change on retry.
export const retryUnlessClientError = (failureCount, err) => {
  const status = err?.response?.status;
  return (!status || status >= 500) && failureCount < 2;
};

export const serverErrorMessage = (err, fallback = "Something went wrong. Try reloading.") => {
  if (err?.response?.status === 404) {
    return "The server doesn't have this feature yet. Redeploy the server with the latest code, then reload.";
  }
  if (!err?.response) return "Could not reach the server. Check your connection and try again.";
  return err.response.data?.message || fallback;
};
